import React, { Component } from "react";
import { Select } from "antd";

import PropTypes from "prop-types";
import Tag from "../../../components/filter/Tag";

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ""
    };
  }

  onChange(v = []) {
    if (this.props.onChange) {
      this.props.onChange(v);
    }
  }

  valueToStr(value) {
    const { type, label_mapping } = this.props;
    switch (type) {
      case Boolean: {
        return value && value === "1" ? "Oui" : "Non";
      }
      case Number: {
        return value + "";
      }
      default:
        if (label_mapping && label_mapping.hasOwnProperty(value)) return label_mapping[value].value_fr;
        return value;
    }
  }

  getOptions() {
    const options = [];
    let filters = this.props.data || [];

    let _data = this.props.data || [];
    if (typeof _data === "function") {
      _data = _data(this.props.kpi);
    }

    let i = 0;
    while (i < _data.length && options.length < 300) {
      const filter = _data[i];
      if (!filter) break;

      if (
        typeof filter["value"] === "number" ||
        typeof filter["value"] === "boolean" ||
        (typeof filter["value"] === "string" &&
          filter["value"].toUpperCase().indexOf(this.state.searchValue.toUpperCase()) !== -1) ||
        (this.props.currentFilters && this.props.currentFilters.indexOf(filter["id"]) !== -1)
      ) {
        options.push(<Select.Option key={filter["id"] || ""}>{this.valueToStr(filter["value"])}</Select.Option>);
      }

      i++;
    }
    return options;
  }

  render() {
    let { kpi, data, type, mode, loading, placeholder, defaultValue, value, onFocus, onChange, ...rest } = this.props;
    const options = this.getOptions();

    let _data = data;
    if (typeof _data === "function") {
      _data = data(kpi);
    }

    return (
      <div>
        <Select
          filterOption={(input, option) => {
            return typeof option.props.children === "string"
              ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              : false;
          }}
          value={value}
          onSearch={value => {
            this.setState({
              searchValue: value
            });
          }}
          mode={mode || type === Boolean ? "default" : "multiple"}
          maxTagCount={0}
          maxTagPlaceholder={(items = [], b, c) => {
            return <Tag items={items} data={this.props.dataSelected} label={placeholder} />;
          }}
          style={{ width: "100%" }}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={v => {
            this.onChange(v);
          }}
          onDropdownVisibleChange={() => {
            this.setState({
              searchValue: ""
            });
            if (onFocus) {
              onFocus();
            }
          }}
          loading={loading}
          notFoundContent={"Aucune donnée"}
          allowClear={true}
          showArrow={false}
          {...rest}
          data={_data}
        >
          {options}
        </Select>
      </div>
    );
  }
}

Filter.propTypes = {
  loading: PropTypes.bool,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func,
  value: PropTypes.array,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  type: PropTypes.any
};

export default Filter;



// WEBPACK FOOTER //
// src/modules/stats/components/Filter.js